<template>
  <div class="footer">
    <div class="footer-info">
      <a
        class="facebook-link"
        href="https://www.facebook.com/LongQiWenHeng/"
        target="_blank"
      >
        <img class="facebook" src="~@/assets/images/facebook-icon.png" />
      </a>
      <div class="footer-title">龍崎文衡殿</div>
      <div class="footer-tel">TEL/06-594-0050</div>
      <div class="footer-address">ADD/台南市龍崎區中坑里中坑3-2號</div>
    </div>

    <div class="footer-readme">
      Copyright ©2020 龍崎文衡殿 All Rights Reserved. Design by
      <a
        class="footer-softmobile-link"
        href="http://www.softmobile.com.tw"
        target="_blank"
        >Softmobile</a
      >
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer',
};
</script>
<style scoped>
.footer {
  width: 100%;
  margin: auto;
  padding-top: 30px;
  text-align: center;
  line-height: 30px;
  color: #565656;
}
.footer-info {
  font-size: 15px;
  border-bottom: 1px solid;
  border-top: 1px solid;
  border-color: rgba(1, 1, 1, 0.2);
  padding: 15px;
}
.footer-title {
  display: inline-block;
}
.footer-tel {
  display: inline-block;
}
.footer-address {
  display: inline-block;
}
.footer-readme {
  font-size: 12px;
  padding: 15px;
}
.footer-softmobile-link {
  color: #8d7f6d;
  font-weight: bold;
}
.footer-softmobile-link:hover {
  color: #aaa;
  text-decoration: none;
}

.facebook-link {
  margin: 0px auto;
  height: 40px;
  width: 40px;
  margin-bottom: 15px;
  display: block;
}
.facebook {
  height: 40px;
  width: 40px;
}
.facebook:hover {
  opacity: 0.7;
}

@media (max-width: 767px) {
  .footer-title {
    display: block;
  }
  .footer-tel {
    display: block;
  }
  .footer-address {
    display: block;
  }
}
</style>
